<template>
  <div>
    <div class="stats-table maxwidth left">
      <table class="small-size-on-mobile">
        <thead>
          <tr class="sumrow">
            <th colspan="2">{{match.teams[teamI].name}} Batting</th>
            <th>R</th>
            <th>B</th>
            <th>4s</th>
            <th>6s</th>
            <th>SR</th>
          </tr>
        </thead>
        <tbody>
        <cricket-match-scorecard-innings-bat-line
          v-if="innings.batting_order"
          v-for="playerKey in innings.batting_order"
          :key="playerKey"
          :match="match"
          :playerKey="playerKey"
          :inningsNumber="inningsNumber"
          @playerSelected="onPlayerSelected"
          @ballSelected="onBallSelected"></cricket-match-scorecard-innings-bat-line>
          <tr class="sumrow">
            <td>Extras</td>
            <td colspan="5">{{innings.wide}} wide, {{innings.noball}} noball, {{innings.legbye}} leg bye, {{innings.bye}} bye, {{innings.penalty}} penalty</td>
            <td class="alert bold right">{{innings.extras}}</td>
          </tr>
          <tr class="sumrow heightspace">
            <td class="bold">Total</td>
            <td colspan="2">{{innings.balls}} balls, {{innings.dotballs}} dots, {{innings.fours}}x4s, {{innings.sixes}}x6s, {{innings.run_rate}} SR</td>
            <td colspan="4" class="highlight sum right">{{innings.runs}}/{{innings.wickets}} ({{innings.overs}} ov)</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="div-bottom-space" v-if="innings && innings.starting_bowling_end">
      <div>
        {{match.teams[teamI].short_name}}<span v-if="inningsNumber && match.format == 'test'">(Inn {{inningsNumber}})</span>
        start with
        <span class="header-color">{{innings.starting_bowling_end}}</span>
      </div>
    </div>
    
    <div v-if="notPlayed().length > 0">
      <span class="header-color">Not Played: </span>
      <ul class="vertical">
        <li
          class="clickable"
          v-for="playerKey in notPlayed()"
          :key="playerKey"
          @click="onPlayerSelected(playerKey)">{{match.players[playerKey].name}}<span class="sep">,</span></li>
      </ul>
      <br/>
      <br/>
    </div>

    <div v-if="innings.wicket_order && innings.wicket_order.length > 0">
      <h5>Fall of Wickets</h5>
      <ul class="">
        <li
          v-for="playerKey in innings.wicket_order"
          :key="playerKey">
          <span
            class="clickable changing"
            v-if="match.players[playerKey] && match.players[playerKey].match && match.players[playerKey].match.innings"
            @click="onBallSelected(match.players[playerKey].match.innings[inningsNumber].batting.ball_of_dismissed)">
            {{fowBatsmanString(playerKey)}}
          </span>
          <span
            class="clickable"
            @click="onPlayerSelected(playerKey)" v-if="match.players[playerKey] && match.players[playerKey].name">
            {{match.players[playerKey].name}}
          </span>
        </li>
      </ul>
    </div>
    <div class="stats-table maxwidth left" v-if="bowlInnings && bowlInnings.bowling_order && bowlInnings.bowling_order.length > 0">
      <table class="small-size-on-mobile">
        <thead>
          <tr class="sumrow">
            <th>Bowler</th>
            <th>O</th>
            <th>M</th>
            <th>R</th>
            <th>W</th>
            <th>Econ</th>
            <th>WD</th>
            <th>NB</th>
          </tr>
        </thead>
        <tbody>
        <cricket-match-scorecard-innings-bowl-line
          v-for="playerKey in bowlInnings.bowling_order"
          :key="playerKey"
          :match="match"
          :playerKey="playerKey"
          :inningsNumber="inningsNumber"
          @playerSelected="onPlayerSelected"></cricket-match-scorecard-innings-bowl-line>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {

  data () {
    const otherTeamI = (this.teamI === 'a') ? 'b' : 'a'
    return {
      otherTeamI
    }
  },
  props: {
    match: Object,
    inningsNumber: String,
    teamI: String
  },
  computed: {
    innings () {
      return this.match.innings[`${this.teamI}_${this.inningsNumber}`]
    },

    bowlInnings () {
      return this.match.innings[`${this.otherTeamI}_${this.inningsNumber}`]
    }
  },

  methods: {
    fowBatsmanString (playerKey) {
      const player = this.match.players[playerKey]
      const playerInn = player.match.innings[this.inningsNumber].batting
      if(playerInn && playerInn.dismissed) {
        const dismissedInfo = playerInn.dismissed_at
        return `${dismissedInfo.team_runs}/${dismissedInfo.wicket_index} (${dismissedInfo.over - 1}.${dismissedInfo.ball} ov)`
      }
    },

    notPlayed () {
      let players = this.match.teams[this.teamI].match.playing_xi.slice()
      this.innings.batting_order.forEach((key) => {
        const i = players.indexOf(key)
        if (i > -1) {
          players.splice(i, 1)
        }
      })

      return players
    },

    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    },
    onBallSelected (ball) {
      this.$emit('ballSelected', ball)
    }
  }
}
</script>
